/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 15.10.25
 *
 */
import BaseExtraItem from "@tl/core/modules/commission/model/extras/BaseExtraItem";

export default class TherapeuticToolItem extends BaseExtraItem {

	usefulFor: string[] = []
	purpose: string = null
	methodology: string = null
	isStandardTool: boolean = false

	constructor(options) {
		super(options);
		this.applyOptions(options);
	}
}
